import { create } from 'zustand';

interface SyncDataState {
  errors: any[] | null;
  payload: Record<string, any> | null;
  setErrors: (errors: any[] | null) => void;
  setPayload: (payload: Record<string, any> | null) => void;
  reset: () => void;
}

export const useSyncDataStore = create<SyncDataState>((set) => ({
  errors: null,
  payload: null,
  setErrors: (errors) => set({ errors }),
  setPayload: (payload) => set({ payload }),
  reset: () => set({ errors: null, payload: null }),
}));
